import ChildCountRoutes from './child-count';
import DisciplineCertificationRoutes from './discipline-certification';
import EvaluationHistoryRoutes from './evaluation-history';
import EvaluationRequestManagment from './evaluation-request-management';
import FollowUpGraduateInterview from './follow-up-graduate-interview';
import EvaluationDiscussionRoutes from './evaluation-discussion';
import ReferralPartCToPartB from './referral-part-c-to-part-b';
import TeacherSatisfactionQuestionnaire from './teacher-satisfaction-questionnaire';
import AutismSurveillanceNetwork from './autism-surveillance-network';
import StudentsVisualImpairments from './students-visual-impairments';
import GraduationCertification from './graduation-certification';
import MedicalPlan from './medical-plan';

export default [
  ...EvaluationHistoryRoutes,
  ...EvaluationRequestManagment,
  ...FollowUpGraduateInterview,
  ...ChildCountRoutes,
  ...EvaluationDiscussionRoutes,
  ...ReferralPartCToPartB,
  ...TeacherSatisfactionQuestionnaire,
  ...AutismSurveillanceNetwork,
  ...StudentsVisualImpairments,
  ...DisciplineCertificationRoutes,
  ...GraduationCertification,
  ...MedicalPlan,
];
